import { KText } from '@/ui-library/components/text';
import { Radio } from '@kula-ai/components';
import { Flex, Icon, Stack } from '@chakra-ui/react';
import { useField } from 'formik';

export const RadioGroupFieldV2 = ({ item, field }) => {
  const {
    options,
    name,
    styles,
    disabled = false,
    radioStyles = {},
    radioWrapperStyles = {},
    radioLabelStyles = {},
    radioIconStyles = {},
    radioOptionsDirection = 'row',
    editable = true,
    onChange = () => {},
  } = item;

  const [, , helpers] = useField(name);

  const handleChange = (value: string) => {
    helpers?.setValue?.(value);
    onChange?.(value);
  };

  return (
    <Stack
      id={name}
      direction={radioOptionsDirection}
      pointerEvents={!editable ? 'none' : 'auto'}
      {...styles}
    >
      {options?.map((option) => (
        <Flex
          key={option?.value}
          flexDir="column"
          cursor={option?.disabled || disabled ? 'not-allowed' : 'pointer'}
          onClick={() =>
            !option?.disabled && !disabled && handleChange(option?.value)
          }
          {...radioWrapperStyles}
          {...option?.radioWrapperStyles}
        >
          <Flex alignItems="flex-start" gap="8px">
            {option?.icon && (
              <Icon
                as={option?.icon}
                className="primary-900"
                {...radioIconStyles}
                {...option?.radioIconStyles}
              />
            )}
            <Radio
              name={name}
              value={option?.value}
              label={option?.label}
              checked={field?.value === option?.value}
              disabled={option?.disabled || disabled}
              onChange={() => handleChange(option?.value)}
              {...radioStyles}
              {...option?.radioStyles}
              labelClassName={radioLabelStyles?.className}
            />
          </Flex>
          {option?.desc && (
            <KText fontSize="sm" color="secondary-700" pl="28px">
              {option?.desc}
            </KText>
          )}
        </Flex>
      ))}
    </Stack>
  );
};
